import { render } from "./assetmodel.vue?vue&type=template&id=17ac860c&scoped=true"
import script from "./assetmodel.vue?vue&type=script&lang=js"
export * from "./assetmodel.vue?vue&type=script&lang=js"

import "./assetmodel.vue?vue&type=style&index=0&id=17ac860c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17ac860c"]])

export default __exports__